import React, { ReactElement } from "react";

type Props = {
  header: string;
  count: number;
};

export default function SectionHeader(props: Props): ReactElement {
  const { header, count } = props;

  return (
    <div className="flex w-full justify-between justify-items-center h-fit mt-[50px]">
      <h2 className="text-[24px] text-rose-600 space-x-2">
        <span>{header}</span>
        <span className="text-[16px] text-slate-400">({count})</span>
      </h2>
    </div>
  );
}
